/**
 * Use "mfr:filter-press-grid" event and pass filter object for filtering
 */
class MFRGridWithMetafieldsFiltering {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      grid: ".press-grid__articles",
      json: ".press-grid__json",
      article: ".press-grid__article",
      card: ".press-card",
      cardImage: ".press-card__image img",
      cardTitle: ".press-card__title",
      cardDatePublished: ".press-card__date-published",
      loadMore: ".press-grid__load-more",
      selectedFilters: ".press-grid__filter-selected",
      removeFilter: ".press-grid__filter-remove",
      selectedFiltersWrapper: ".press-grid__filter-inner",
      clearFilter: ".press-grid__filter-clear",
    };

    this.articles = [];
    this.postPerPage = 4;
    this.currentPage = 1;
    this.currentFilter = {};
    this.currentArticles = [];

    this.init();
  }

  init() {
    this.$template = this.$element.find("template");
    this.$jsons = this.$element.find(this.selectors.json);
    this.$grid = this.$element.find(this.selectors.grid);
    this.$loadMore = this.$element.find(this.selectors.loadMore);
    this.$selectedFiltersWrapper = this.$element.find(
      this.selectors.selectedFiltersWrapper
    );
    this.$selectedFilters = this.$element.find(this.selectors.selectedFilters);
    this.$clearFilter = this.$element.find(this.selectors.clearFilter);

    this.initJSON();
    this.populateGrid(this.paginate(this.currentPage));

    if (!this.paginate(this.currentPage + 1).length) this.$loadMore.fadeOut();
    else this.$loadMore.fadeIn();

    this.$loadMore.find("a").on("click", this.__handleLoadMore.bind(this));
    this.$element.on("mfr:filter-press-grid", this.__handleFilter.bind(this));
    this.$clearFilter.on("click", this.__handleClearFilter.bind(this));

    $(document).on(
      "click",
      this.selectors.removeFilter,
      this.__handleFilterRemove.bind(this)
    );
  }

  __handleLoadMore(e) {
    this.currentPage++;

    if (this.currentFilter.length) {
      this.populateGrid(
        this.paginate(
          this.currentPage,
          this.filter(this.articles, this.currentFilter)
        ),
        true
      );
    } else {
      this.populateGrid(this.paginate(this.currentPage), true);
    }

    if (!this.paginate(this.currentPage + 1).length) {
      this.$loadMore.fadeOut();
    }
  }

  __handleFilter(e, data) {
    this.applyFilter(data);
  }

  __handleFilterRemove(e) {
    const key = $(e.currentTarget).data("key");

    delete this.currentFilter[key];

    $(`input[name="${key}"]`).prop("checked", false);

    this.applyFilter(this.currentFilter);
  }

  __handleClearFilter(e) {
    $.each(this.currentFilter, (i, e) => {
      $(`input[name="${i}"]`).prop("checked", false);
    });
    this.applyFilter({});
  }

  initJSON() {
    this.$jsons.each((i, e) => {
      const articleARR = JSON.parse(
        $(e)
          .text()
          .replaceAll(",}", "}")
          .replaceAll(",]", "]")
          .replaceAll(/(\r\n|\n|\r)/gm, "")
      );
      this.articles = this.currentArticles = [...this.articles, ...articleARR];
      this.articles = this.currentArticles = this.currentArticles.sort(
        function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(b.metafields.date_published) -
            new Date(a.metafields.date_published)
          );
        }
      );
    });
    this.$jsons.remove();
  }

  applyFilter(data) {
    this.currentPage = 1;
    this.filter(this.articles, data);
    this.populateGrid(this.paginate(this.currentPage));

    if (this.paginate(this.currentPage + 1).length) this.$loadMore.fadeIn();
    else this.$loadMore.fadeOut();

    if (!Object.keys(data).length) this.$selectedFiltersWrapper.hide();
    else this.$selectedFiltersWrapper.show();

    this.currentFilter = data;

    this.$selectedFilters.find("li").remove();
    $.each(this.currentFilter, (i, e) => {
      this.$selectedFilters.append(`
        <li>
          ${e} 
          <button 
            class="${this.selectors.removeFilter.replace(".", "")}"
            data-key="${i}"
            >&times;</button>
        </li>
      `);
    });
    lozad("img.lozad").observe();
  }

  populateGrid(articles, append = false) {
    if (!append) {
      this.$grid.find(this.selectors.article).each((i, e) => {
        $(e).fadeOut(() => {
          $(e).remove();
        });
      });
    }

    setTimeout(() => {
      $.each(articles, (i, e) => {
        const article = this.generateHTML();
        const { id, tag, image, title, cardReadingTime, url } = e;
        const options = {
          year: "numeric",
          month: "short",
          day: "numeric",
        };

        article.attr("id", `press-card-${id}`);
        article.attr("aria-label", title);
        article.attr("title", title);

        article.find(this.selectors.card).attr("href", url);
        article.find(this.selectors.cardTitle).html(title);
        article
          .find(this.selectors.cardDatePublished)
          .text(
            new Date(e.metafields.date_published).toLocaleDateString(
              "en-US",
              options
            )
          );
        article.find(this.selectors.cardImage).attr("src", image);
        article.hide();

        this.$loadMore.before(article);
        article.fadeIn();
      });
    }, 400);
  }

  paginate(page_number, articles = false) {
    articles = articles ? articles : this.currentArticles;
    const page_size = this.postPerPage;
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return articles.slice(
      (page_number - 1) * page_size,
      page_number * page_size
    );
  }

  filter(articles, filters) {
    if (!Object.keys(filters).length) {
      this.currentArticles = this.articles;
      return;
    }

    this.currentArticles = articles.filter((e, i) => {
      let show = false;
      $.each(filters, (filterIndex, filterValue) => {
        if (e["metafields"][filterIndex]?.split(",").includes(filterValue)) {
          show = true;
          return;
        }
      });
      return show;
    });
  }

  generateHTML() {
    let article = this.$template.clone().html().trim();
    return $(article);
  }
}
